import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';
import { ValidationPatterns } from '../../helpers/validation-patterns';
import { PlatformService } from '../../services/platform.service';

@Directive({
    selector: '[InputLettersSymbols]',

})
export class InputLettersSymbolsDirective implements AfterViewInit {
  private _el = inject(ElementRef);
  private _platform = inject(PlatformService);


  ngAfterViewInit(): void {
    if (!this._platform.isBrowser) return;
    const regEx = ValidationPatterns.lettersAndSpecialSymbols;
    this._el.nativeElement.addEventListener('keypress', (event) => {
      const char = event.key !== undefined ? event.key : String.fromCharCode(event.keyCode);
      if (!regEx.test(char)) {
        event.preventDefault();
      }
    });
  }
}
